import { UiGroupControl } from "./ui-group-control.model";
import { TabOptions } from '../../interfaces/tab-option.interface';

export class GridControl extends UiGroupControl {

  gridOptions: TabOptions;
  parentEntityId: string;

  constructor(options: TabOptions) {
    super(options.name, options.label);

    this.className = "GridControl";
    this.gridOptions = options;
  }

}
